module.exports = __webpack_public_path__ + "img/sign-80.12fb219e.jpg";